import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSession } from '../lib/session';
import { safeConversionPath } from '../lib/sessionFlow';
export default function TrialNotice() {
  const { t } = useTranslation();
  const trial = useSession(state => state.state);
  if (trial?.principalKind !== 'anonymous' || trial.limit === 0) return null;
  return (
    <aside
      className="trial-notice"
      role="status"
      style={{
        padding: '10px 24px',
        textAlign: 'center',
        background: 'var(--accent-dim)',
      }}
    >
      {trial.exhausted ? (
        <Link to={safeConversionPath(trial.conversionPath)}>
          {t('trial.usedLast')}
        </Link>
      ) : (
        t('trial.counter', { count: trial.scansUsed, limit: trial.limit })
      )}
    </aside>
  );
}
